<template>
    <v-form @submit.prevent ref="form">
    <v-alert type="success" :value="success" transition="slide-x-transition">
        Vaše heslo bolo úspešne zmenené
    </v-alert>
    <v-container>
        <v-row justify="center">
            <h2>
                <span class="pa-1">Zmena prihlasovacích údajov</span>
            </h2>
        </v-row>

        <v-row class="justify-center">
            <v-col cols="4">
                <v-text-field
                        validate-on-blur
                        :rules="noEmpty"
                        v-model="oldPassword"
                        class="text-input-black"
                        type="password"
                        label="Aktuálne heslo">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row class="justify-center">
            <v-col cols="4">
                <v-text-field
                        validate-on-blur
                        :rules="rules"
                        v-model="password"
                        class="text-input-black"
                        type="password"
                        label="Nové heslo">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row class="justify-center">
            <v-col cols="4">
                <v-text-field
                        validate-on-blur
                        :rules="rules"
                        v-model="password2"
                        class="text-input-black"
                        type="password"
                        label="Potvrďte nové heslo">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row class="justify-center">
            <v-col cols="4">
                <span class="red--text">{{error}}</span>
            </v-col>
        </v-row>
        <v-row class="justify-center">
            <v-col class="text-center" cols="12">
                <v-btn @click="changePassword()"
                color="accent" 
                >
                    Zmeniť heslo
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
    </v-form>
</template>

<script>
    import axios from 'axios';
    import store from "../../store/store";

    export default {
        name: "changePassword",
        data: () => ({
            rules: [
                value => !!value || 'Vyplňte prosím toto pole.',
                value => (value && value.length >= 6) || 'Minimálne 6 znakov',
            ],
            noEmpty: [
                value => !!value || 'Vyplňte prosím toto pole',
            ],
            oldPassword: '',
            password: '',
            password2: '',
            error : '',
            success: false,

        }),
        methods: {
            alertPasswordChanged() {
                this.success = true;
                setTimeout(() => {
                    this.success = false;
                }, 2500)
            },
            changePassword(){
                //if(!this.refForm.validate()) return;
                this.error = '';
                const params = new URLSearchParams();
                params.append('user', localStorage.getItem('loggedUserId'));
                params.append('oldPassword', this.oldPassword);
                params.append('password', this.password);
                params.append('confirmPassword', this.password2);
                axios({
                    method: 'post',
                    url: store.state.url.concat('changePassword.php'),
                    data: params
                }).then((response) => {
                    if(response.data.result == 'ok') {
                        alert('Vaše heslo bolo úspešne zmenené.');
                        this.$router.push({name: 'profile'});
                    }else{
                        this.error = response.data.error;
                    }
                });

            }
        }
    }
</script>
